import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Button,
  Tabs,
  Tab,
  Box,
  Divider,
} from "@mui/material";
import { useDeleteDetail, useFetchDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import HeroCst from "@components/HeroCst";
import { MethodType } from "src/services/type";
import { fetcher } from "src/services/config";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { useTranslation } from "react-i18next";
import AddEditFormNewCst from "@components/AddEditFormNewCst";
import ButtonCst from "@components/ButtonCst";
import { useTheme } from "@mui/material/styles";
interface Props {
  externalCertificateId: any;
  onSuccess: () => void;
}

const DeleteModalCompletions: React.FC<Props> = ({
  externalCertificateId,
  onSuccess,
}) => {
  const theme = useTheme();
  const { t } = useTranslation(["rooms-page"]);
  const [tabIndex, setTabIndex] = useState(0);
  const [deleteRequestId, setDeleteRequestId] = useState<string>("");

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
  }>();

  const { trigger: triggerPutRoom, setId: setDeleteRequest } = useDeleteDetail(
    `${ServicesURL.deleteExternalCertificate}`,
  );

  useEffect(() => {
    if (!deleteRequestId) return;

    const doDelete = async () => {
      try {
        await triggerPutRoom();
        setOpenToast({ s: StatusEnum.OK, message: "" });
      } catch (error) {
        setOpenToast(undefined);
        console.error(error);
      }
    };

    doDelete();
  }, [deleteRequestId, triggerPutRoom]);

  const onSubmit = () => {
    setDeleteRequest(externalCertificateId);
    setDeleteRequestId(externalCertificateId);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          mt: 0,
        }}
      >
        <HeroCst title="Elimina richiesta" description={""} />
        <Box sx={{ mt: "25px" }}>
          <Box sx={{ display: "flex", gap: 4 }}>
            <ButtonCst
              id={"back-button"}
              variant={"outlined"}
              size={"medium"}
              sx={{
                minWidth: "150px",
                mr: "auto",
                [theme.breakpoints.down("lg")]: {
                  minWidth: "100px",
                },
                [theme.breakpoints.down("sm")]: {
                  minWidth: "100%",
                },
              }}
              onClick={() => {
                setOpenToast(undefined);
                onSuccess();
              }}
            >
              Indietro
            </ButtonCst>
            <ButtonCst
              id={"delete-button"}
              variant={"contained"}
              size={"medium"}
              onClick={() => onSubmit()}
            >
              Conferma eliminazione
            </ButtonCst>
          </Box>
        </Box>
      </Box>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-edit")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
          onSuccess();
        }}
        status={openToast}
        routeToSamePage={true}
      />
    </>
  );
};

export default DeleteModalCompletions;
